import {resolveSelectedProperty} from './index';

/**
 * Returns property selector parts for a set of properties
 * @function resolveSelectedProperties
 * @private
 *
 * @param {Object} componentRegistry - Component registry
 * @param {function} propertyResolver - Returns the value for a property
 * @param {Object} properties - A set of properties to be resolved
 * @param {Object} propertiesDef - property definition from the config
 * @returns {Object} - A set of resolved properties
 */
export default function resolveSelectedProperties(
	componentRegistry,
	propertyResolver,
	properties,
	propertiesDef = {}
) {
	if (!hasSelectedProperty(componentRegistry, propertyResolver, properties, propertiesDef)) {
		return properties;
	}

	const resolved = {};
	for (const propName in properties) {
		resolved[propName] = resolveSelectedProperty(
			componentRegistry,
			propertyResolver,
			properties[propName],
			propertiesDef[propName]
		);
	}

	return resolved;
}

function hasSelectedProperty(componentRegistry, propertyResolver, properties, propertiesDef = {}) {
	for (const propName in properties) {
		let resolvedProp = resolveSelectedProperty(
			componentRegistry,
			propertyResolver,
			properties[propName],
			propertiesDef[propName]
		);

		if (properties[propName] === resolvedProp) {
			continue;
		}

		return true;
	}
}
